<template>
  <!-- 2026-09-22：点击说明旁录像机播放，关闭、换页时卸载视频以立即停止播放。 -->
  <a-modal :visible="visible" :title="title + ' · 功能演示'" :footer="null" :width="860" :destroyOnClose="true" @cancel="$emit('close')">
    <div v-if="visible && safeUrl" class="function-video">
      <video :key="safeUrl" :src="safeUrl" controls playsinline preload="metadata" @error="failed = true" @loadeddata="failed = false"></video>
      <p v-if="failed" role="alert">视频暂时无法播放，请检查网络或联系管理员核对视频地址。</p>
    </div>
  </a-modal>
</template>
<script lang="ts">
// 2026-09-22：只播放有效网络视频，不把配置当作HTML或嵌入页面执行。
import { computed, defineComponent, ref, watch } from 'vue'
import { safeFunctionVideoUrl } from '@/utils/functionGuides'
export default defineComponent({
  props: { visible: Boolean, url: { type: String, default: '' }, title: { type: String, default: '' } },
  emits: ['close'],
  setup(props) {
    const failed = ref(false)
    const safeUrl = computed(() => safeFunctionVideoUrl(props.url))
    watch(() => [props.visible, props.url], () => { failed.value = false })
    return { failed, safeUrl }
  }
})
</script>
<style scoped>
/* 2026-09-22：横竖视频均限制在弹窗内，保留原比例和原生播放控制。 */
.function-video video { display:block; width:100%; max-height:70vh; background:#000; }
.function-video p { color:#cf1322; margin:12px 0 0; }
</style>
